var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-navigation-drawer', {
    attrs: {
      "app": "",
      "clipped": "",
      "fixed": "",
      "right": "",
      "permanent": ""
    }
  }, [_c('v-list', [_c('v-list', {
    attrs: {
      "subheader": ""
    }
  }, [_c('v-subheader', [_vm._v(" Table Visualizations ")]), _c('v-divider'), _vm._l(_vm.apps.table_visualizations, function (app) {
    return _c('v-list-item', {
      key: app.name,
      staticClass: "pl-2",
      attrs: {
        "href": "".concat(app.url, "/?workspace=").concat(_vm.workspace, "&table=").concat(_vm.table),
        "target": "_blank"
      }
    }, [_c('v-list-item-avatar', {
      staticClass: "mr-3"
    }, [_c('v-icon', {
      attrs: {
        "color": "blue lighten-3"
      }
    }, [_vm._v(" mdi-exit-to-app ")])], 1), _c('v-list-item-title', [_vm._v(" " + _vm._s(app.name) + " ")]), _c('v-list-item-icon', [_c('v-icon', {
      attrs: {
        "color": "blue lighten-3"
      }
    }, [_vm._v(" mdi-chevron-right ")])], 1)], 1);
  }), _c('v-subheader', {
    staticClass: "pr-2"
  }, [_vm._v(" All Tables ")]), _c('v-divider'), _vm.loadingTables ? _c('div', [_c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  }), _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  }), _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item"
    }
  })], 1) : _vm._e(), _vm._l(_vm.tables, function (t) {
    return _c('v-list-item', {
      key: t.name,
      attrs: {
        "ripple": "",
        "to": "/workspaces/".concat(_vm.workspace, "/table/").concat(t.name)
      }
    }, [_c('v-list-item-action', [_c('v-icon', {
      attrs: {
        "color": "primary"
      }
    }, [_vm._v(" mdi-table ")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(t.name))])], 1)], 1);
  })], 2)], 1)], 1), _c('v-main', [_c('v-app-bar', {
    attrs: {
      "app": "",
      "clipped-right": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "ws-detail-title"
  }, [_c('v-icon', {
    staticClass: "ml-4 mr-5",
    attrs: {
      "color": "grey lighten-1"
    }
  }, [_vm._v(" mdi-text-box-multiple ")]), _c('span', {
    staticClass: "breadcrumbs"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'workspaceDetail',
        params: {
          workspace: _vm.workspace
        }
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.workspace) + " ")]), _c('v-icon', {
    staticClass: "mx-4",
    attrs: {
      "color": "grey lighten-2"
    }
  }, [_vm._v("mdi-chevron-right")]), _c('v-icon', {
    staticClass: "mr-3",
    attrs: {
      "color": "grey lighten-1"
    }
  }, [_vm._v("mdi-table")]), _vm._v(" " + _vm._s(_vm.table) + " ")], 1)], 1), _c('v-spacer'), _c('workspace-option-menu', {
    attrs: {
      "workspace": _vm.workspace
    }
  })], 1), _c('div', {
    staticClass: "wrapper"
  }, [_c('v-data-table', {
    staticClass: "table-details",
    attrs: {
      "fixed-header": "",
      "height": "calc(100vh - 123px - 63px)",
      "headers": _vm.dataTableHeaders,
      "hide-default-header": "",
      "items": _vm.dataTableRows,
      "footer-props": {
        itemsPerPageOptions: [10, 20, 50, 100],
        showFirstLastPage: true
      },
      "server-items-length": _vm.tableSize,
      "options": _vm.pagination,
      "loading": _vm.loading
    },
    on: {
      "update:options": function updateOptions($event) {
        _vm.pagination = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn() {
        return [_c('thead', {
          attrs: {
            "dark": ""
          }
        }, [_c('tr', _vm._l(_vm.dataTableHeaders, function (header, i) {
          return _c('th', {
            key: i,
            staticClass: "pt-2 pb-2"
          }, [_vm._v(" " + _vm._s(header.text) + " "), _vm.columnTypes[header.text] ? _c('span', [_vm._v(" (" + _vm._s(_vm.columnTypes[header.text]) + ") ")]) : _vm._e()]);
        }), 0)])];
      },
      proxy: true
    }])
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }